// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"61":"41edae6d","298":"afea89fd","323":"babd2638","453":"af0c7dde","519":"2d3a7e37","616":"5f640525","802":"2208360b","862":"e707502b","881":"fb34df67","960":"4c9bffcc"}[chunkId] + ".chunk.js";
};